import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import pl from './resources/pl'
import de from './resources/de'
import en from './resources/eng'
import ro from './resources/ro'
import mobileDeErrors from './resources/mobileDeErrors'

export const resources = {
  pl: {
    translation: {
      ...pl,
      mobile_de_errors: mobileDeErrors.pl
    }
  },
  de: {
    translation: {
      ...de,
      mobile_de_errors: mobileDeErrors.de
    }
  },
  en: {
    translation: {
      ...en,
      mobile_de_errors: mobileDeErrors.en
    }
  },
  ro: {
    translation: {
      ...ro,
      mobile_de_errors: mobileDeErrors.ro
    }
  }
}
export type TranslationFnType = (name: string) => string

i18n
  .use(initReactI18next)
  .init({
    resources,
    compatibilityJSON: 'v3',
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  })
  .catch(() => null)
